
export const MaterialType = {
  materialTypeOptions: [{ label: 'type1', value: 1, active: true },
    { label: 'type2', value: 0, active: true }],
  i18nKey: 'materialTypeT',
  zhCn: {
    materialTypeT: {
      type1: '模切型',
      type2: '连续型'
    }
  },
  en: {
    materialTypeT: {
      type1: '模切型',
      type2: '连续型'
    }
  }
}
